"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamMetadataDecoder = void 0;
const StreamMetadata_1 = require("./StreamMetadata");
const LogicalLevelTechnique_1 = require("./LogicalLevelTechnique");
const PhysicalLevelTechnique_1 = require("./PhysicalLevelTechnique");
const MortonEncodedStreamMetadata_1 = require("./MortonEncodedStreamMetadata");
const RleEncodedStreamMetadata_1 = require("./RleEncodedStreamMetadata");
class StreamMetadataDecoder {
    static decode(tile, offset) {
        const streamMetadata = StreamMetadata_1.StreamMetadata.decode(tile, offset);
        if (streamMetadata.logicalLevelTechnique1() === LogicalLevelTechnique_1.LogicalLevelTechnique.MORTON) {
            return MortonEncodedStreamMetadata_1.MortonEncodedStreamMetadata.decodePartial(streamMetadata, tile, offset);
        }
        else if ((LogicalLevelTechnique_1.LogicalLevelTechnique.RLE === streamMetadata.logicalLevelTechnique1() ||
            LogicalLevelTechnique_1.LogicalLevelTechnique.RLE === streamMetadata.logicalLevelTechnique2()) &&
            PhysicalLevelTechnique_1.PhysicalLevelTechnique.NONE !== streamMetadata.physicalLevelTechnique()) {
            return RleEncodedStreamMetadata_1.RleEncodedStreamMetadata.decodePartial(streamMetadata, tile, offset);
        }
        return streamMetadata;
    }
}
exports.StreamMetadataDecoder = StreamMetadataDecoder;
//# sourceMappingURL=StreamMetadataDecoder.js.map